import { Editor } from '@tiptap/core';

import { isTiptapEditorContentFragmentEmpty } from '../../utils/isTiptapEditorEmpty';
import { TiptapNodeType } from '../../tiptapTypes';

/**
 * Returns true when the editor content is exactly one empty top-level task item with no title.
 */
export const isSingleEmptyTaskListEditor = (editor: Editor): boolean => {
    const documentNode = editor.state.doc;

    if (documentNode.childCount !== 1) return false;

    const taskListNode = documentNode.firstChild;

    if (!taskListNode || taskListNode.type.name !== TiptapNodeType.taskList) return false;
    if (taskListNode.childCount !== 1) return false;

    const taskItemNode = taskListNode.firstChild;

    if (!taskItemNode || taskItemNode.type.name !== TiptapNodeType.taskItem) return false;

    return isTiptapEditorContentFragmentEmpty(taskItemNode.content);
};

export default isSingleEmptyTaskListEditor;
